"use client";

import { cn } from "../../lib/utils/cn";
import { ReactNode, useState } from "react";

type TExpandableDiv = {
  children: ReactNode;
  title: string;
  chldCls?: string;
};

export const ExpandableDiv = ({ children, title, chldCls }: TExpandableDiv) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <div
        className="pr-2 font-bold inline-block cursor-pointer text-gray-400 dark:text-gray-500 relative"
        onClick={() => setShow((s) => !s)}
      >
        <div
          className={cn(
            "px-1 text-base inline-block duration-200 text-gray-400 dark:text-gray-500 absolute -left-7 top-0.5",
            show ? "rotate-90" : "rotate-0",
          )}
        >
          ➤
        </div>
        <span className="italic [font-variant:small-caps] tracking-wider">
          {title}
        </span>
      </div>
      <div
        className={cn(
          "border duration-500 ease-in-out transition-all text-sm bg-black/5 dark:border-white/20 inset dark:bg-slate-900 duration-100 marker:text-sky-500 dark:marker:text-sky-800  prose-ul:list-inside px-2",
          chldCls,
          show ? "visible" : "hidden",
        )}
      >
        {children}
      </div>
    </div >
  );
};
